
import { Calendar, Bell, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NewsSection = () => {
  const { t } = useTranslation();

  const news = [
    {
      id: 1,
      title: 'Yeni Yapay Zeka Sertifika Programı Başlıyor',
      excerpt: 'ChatGPT ve makine öğrenmesi konularında uzmanlaşmak isteyenler için özel olarak tasarlanan program 2025 Ocak ayında başlıyor.',
      date: '18 Aralık 2024',
      type: 'Duyuru',
      urgent: true
    },
    {
      id: 2,
      title: 'Siber Güvenlik Eğitimlerimiz Güncellendi',
      excerpt: 'En son tehditler ve koruma yöntemleri eklenerek siber güvenlik müfredatımız yenilendi.',
      date: '16 Aralık 2024',
      type: 'Güncelleme',
      urgent: false
    },
    {
      id: 3,
      title: 'Öğrenci Başarı Hikayeleri',
      excerpt: 'Sertifika programlarımızı tamamlayan öğrencilerimizin kariyer gelişim hikayeleri.',
      date: '14 Aralık 2024',
      type: 'Haber',
      urgent: false
    },
    {
      id: 4,
      title: 'Yılsonu Kampanyası Başladı',
      excerpt: 'Tüm sertifika programlarında %30 indirim fırsatı. Kampanya 31 Aralık\'a kadar geçerli.',
      date: '13 Aralık 2024',
      type: 'Kampanya',
      urgent: true
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('news.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('news.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {news.map((item) => (
            <div key={item.id} className={`bg-white border rounded-xl p-6 hover:shadow-lg transition-shadow cursor-pointer ${
              item.urgent ? 'border-orange-200 bg-orange-50' : 'border-gray-200'
            }`}>
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center space-x-2">
                  {item.urgent && <Bell className="w-4 h-4 text-orange-500" />}
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    item.type === 'Duyuru' ? 'bg-blue-100 text-blue-800' :
                    item.type === 'Güncelleme' ? 'bg-green-100 text-green-800' :
                    item.type === 'Kampanya' ? 'bg-orange-100 text-orange-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {item.type}
                  </span>
                </div>
                <div className="flex items-center space-x-1 text-sm text-gray-500">
                  <Calendar className="w-4 h-4" />
                  <span>{item.date}</span>
                </div>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {item.title}
              </h3>
              <p className="text-gray-600 mb-4 line-clamp-2">
                {item.excerpt}
              </p>
              
              <button className="flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-medium cursor-pointer">
                <span>Detayları Gör</span>
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
